import $ from 'jquery'
import { GeoJSON } from 'ol/format'

import Spinner from '../ui/Spinner'
import flatten from 'lodash/flatten'
import reverse from 'lodash/reverse'

import setOlgaMetadata from './setOlgaMetadata'

import VectorQuery from './VectorQuery'
import GeoServerWfsQuery from './GeoServerWfsQuery'
import ArcGisWmsQuery from './ArcGisWmsQuery'
import ArcGisWfsQuery from './ArcGisWfsQuery'

/**
 * Identify Query class
 * A queryHandler should return an object with a `query` function and a `isLayerSupported` function
 * The `query` function takes layer configiruation and queryOptions as arguments and returns a `Promise` which should resolve to a GeoJSON object
 * The `isLayerSupported` function takes a layer configiruation and returns true if layer type is supported
 *
 * @param {Object} opt_options
 * @constructor
 */
export default class Query {
  constructor(options) {
    this.layers = options.layers
    this.map = options.map
    this.api = options.api
    this.queryHandlers = [
      VectorQuery(this.map),
      GeoServerWfsQuery(this.map),
      ArcGisWmsQuery(this.map),
      ArcGisWfsQuery(this.map)
    ]
  }

  query(options) {
    var queryLayers = this.layers.filter(this.filterLayers, this)
    return Promise.all(queryLayers.map(this.queryLayer(options), this))
      .then(flatten)
      .then(reverse)
  }

  filterLayers(layer) {
    return !(
      !layer ||
      !layer.metadata ||
      !layer.metadata.identify ||
      layer.visible === false ||
      layer.mapLayer_.getVisible() === false
    )
  }

  getApiResponseHandlers() {
    return this.api.identify
      .getHandlers()
      .filter(handler => handler.type === 'response')
      .reduce((callbacks, handler) => {
        return [...callbacks, handler.callback]
      }, [])
  }

  queryLayer(options) {
    const geoJsonFormat = new GeoJSON(options)
    const readGeoJsonFeatures = geoJsonFormat.readFeatures.bind(geoJsonFormat)
    return (layer, index) => {
      return Promise.all(
        this.queryHandlers
          .filter(handler => handler.isLayerSupported(layer))
          .map(handler => handler.query(layer, options))
      )
        .then(queryHandlerResponses => {
          if (this.getApiResponseHandlers().length) {
            return this.getApiResponseHandlers().reduce(
              (prev, curr) =>
                prev.then(responses => curr(responses, layer, options)),
              Promise.resolve(queryHandlerResponses)
            )
          }
          return queryHandlerResponses
        })
        .then(geoJsonFeatures => geoJsonFeatures.map(readGeoJsonFeatures))
        .then(flatten)
        .then(features => setOlgaMetadata(features, layer))
    }
  }
}
